export const enUS = {
  translation: {
    // Common
    common: {
      save: "Save",
      cancel: "Cancel",
      delete: "Delete",
      edit: "Edit",
      add: "Add",
      search: "Search",
      loading: "Loading...",
      confirm: "Confirm",
      back: "Back",
      next: "Next",
      close: "Close",
      yes: "Yes",
      no: "No",
      all: "All",
      none: "None",
      actions: "Actions",
      view: "View",
      export: "Export",
      import: "Import",
      filter: "Filter",
      clear: "Clear",
      apply: "Apply",
      today: "Today",
      yesterday: "Yesterday",
      tomorrow: "Tomorrow",
      week: "Week",
      month: "Month",
      year: "Year",
      or: "or",
      and: "and",
      of: "of",
      to: "to",
      from: "from",
      active: "Active",
      inactive: "Inactive",
      enabled: "Enabled",
      disabled: "Disabled",
      blocked: "Blocked",
      new: "New",
      create: "Create",
      update: "Update",
      refresh: "Refresh",
      details: "Details",
      status: "Status",
      name: "Name",
      email: "Email",
      phone: "Phone",
      address: "Address",
      date: "Date",
      time: "Time",
      value: "Value",
      total: "Total",
      quantity: "Quantity",
      price: "Price",
      description: "Description",
      notes: "Notes",
      select: "Select",
      selected: "Selected",
      confirmed: "confirmed",
      pending: "Pending",
      completed: "Completed",
      conversion: "conversion",
      optional: "optional",
      see_all: "See all",
      see_all_feminine: "See all",
      no_data: "No data",
      income: "Income",
      expense: "Expense",
      register_transaction: "Register transaction",
      more: "more",
      system: "System",
      user: "User",
      discount: "off",
      min: "Min.",
      until: "Until",
      color: "Color",
      preview: "Preview",
      saving: "Saving...",
      tags: "Tags",
      copy: "Copy",
      error: "Error",
      business: "Business",
      other: "Other",
      type: "Type",
      hello: "Hello",
    },

    // Projects Module
    projects_module: {
      title: "Projects",
      subtitle: "Manage your projects and tasks",
      new_project: "New Project",
      edit_project: "Edit Project",
      create_project: "Create Project",
      delete_project: "Delete Project",
      confirm_delete: "Are you sure you want to delete this project? All associated tasks will also be deleted.",
      no_projects: "No projects found",
      create_first_project: "Create your first project to organize your tasks",
      loading_projects: "Loading projects...",
      active_projects: "Active Projects",
      completed: "Completed",
      start_date: "Start Date",
      end_date: "End Date",
      priority: "Priority",
      deadline: "Deadline",
      status: {
        active: "Active",
        completed: "Completed",
        cancelled: "Cancelled",
      },
    },

    // Tickets
    tickets: {
      title: "Tickets",
      subtitle: "Manage internal requests and issues",
      new_ticket: "New Ticket",
      open_ticket: "Open Ticket",
      ticket_title: "Title",
      title_placeholder: "Briefly describe the issue",
      description_placeholder: "Issue details...",
      category: "Category",
      priority: "Priority",
      open: "Open",
      in_progress: "In Progress",
      resolved: "Resolved",
      search_placeholder: "Search tickets...",
      filter_by_status: "Filter by status",
      all_statuses: "All statuses",
      no_tickets: "No tickets found",
      try_filters: "Try changing the filters",
      open_first_ticket: "Open a ticket to log issues or requests",
      no_description: "No description",
      comments: "Comments",
      no_comments: "No comments",
      add_comment_placeholder: "Add comment...",
      support: "Support",
      you: "You",
    },

    // Notifications
    notifications: {
      title: "Notifications",
      mark_all_read: "Mark all as read",
      no_notifications: "No notifications",
    },

    // Projects
    projects: {
      subtasks: "Subtasks",
      subtask_title: "Subtask title",
      no_subtasks: "No subtasks",
      delete_subtask: "Delete Subtask",
      delete_subtask_confirm: "Are you sure you want to delete this subtask?",
    },

    // Units
    units: {
      members: "Members",
      select_user: "Select user",
      choose_user: "Choose a user...",
      no_name: "No name",
      unit_role: "Role in unit",
      admin_full_access: "Administrator (full access)",
      manager_edit: "Manager (edit data)",
      staff_operations: "Staff (operations)",
      viewer_readonly: "Viewer (read-only)",
      all_users_members: "All users are already members",
      add_member: "Add Member",
      current_members: "Current members",
      no_members: "No members added",
      add_users_access: "Add users to give access to this unit",
      remove_member_confirm: "Remove this member from the unit?",
      role_admin: "Administrator",
      role_manager: "Manager",
      role_staff: "Staff",
      role_viewer: "Viewer",
      manager: "Manager",
      staff: "Staff",
      viewer: "Viewer",
    },

    // Reminders Module
    reminders: {
      title: "Reminders",
      subtitle: "Create reminders to send via WhatsApp, Email or Notification",
      new_reminder: "New Reminder",
      create_reminder: "Create Reminder",
      reminder_title: "Title",
      title_placeholder: "Remember to...",
      description_optional: "Description (optional)",
      description_placeholder: "Reminder details...",
      datetime: "Date/Time",
      notification_type: "Notification Type",
      system_notification: "System Notification",
      whatsapp_phone: "Phone (WhatsApp)",
      phone_placeholder: "+1 (555) 123-4567",
      email_address: "Email",
      email_placeholder: "email@example.com",
      pending: "Pending",
      sent: "Sent",
      all: "All",
      no_pending: "No pending reminders",
      no_sent: "No sent reminders",
      no_created: "No reminders created",
      delete_reminder: "Delete Reminder",
      delete_confirm: "Are you sure you want to delete this reminder?",
      send: "Send",
      sent_badge: "Sent",
      whatsapp_sent: "Reminder sent via WhatsApp!",
      email_sent: "Reminder sent via Email!",
      send_error: "Error sending reminder: ",
      no_whatsapp_instance: "No WhatsApp instance connected",
      notification_label: "Notification",
    },

    // Files Module
    files: {
      title: "Files",
      subtitle: "Manage your files and folders",
      new_folder: "New Folder",
      upload_file: "Upload File",
      folder_name: "Folder Name",
      folder_name_placeholder: "Folder name",
      no_files: "No files",
      no_files_desc: "Upload files or create folders to organize",
      delete_file: "Delete File",
      delete_file_confirm: "Are you sure you want to delete this file? This action cannot be undone.",
      delete_folder: "Delete Folder",
      delete_folder_confirm: "Are you sure you want to delete this folder? This action cannot be undone.",
      download: "Download",
      preview: "Preview",
      all_files: "All Files",
      images: "Images",
      videos: "Videos",
      documents: "Documents",
      searching: "Searching...",
      select_folder: "Select a folder",
      root: "Root",
    },

    // Chatbot Module
    chatbot_module: {
      conversations: "Conversations",
      search_conversations: "Search conversations...",
      no_conversations: "No conversations found",
      unknown: "Unknown",
      contact: "Contact",
      human_control: "Human Control",
      configure: "Configure",
      stats: "Statistics",
      active: "Active",
      waiting: "Waiting",
      closed: "Closed",
      take_over: "Take Over",
      release: "Release",
      close_conversation: "Close",
      create_lead: "Create Lead",
      manage_tags: "Manage Tags",
      no_messages: "No messages yet",
      start_conversation: "Start the conversation by sending a message",
      select_conversation: "Select a conversation",
      select_conversation_desc: "Choose a conversation on the left to view",
      you: "You",
      bot: "Bot",
    },
    
    // Navigation
    nav: {
      dashboard: "Dashboard",
      agenda: "Agenda",
      clients: "Clients",
      products: "Products",
      services: "Services",
      finance: "Finance",
      marketing: "Marketing",
      reports: "Reports",
      settings: "Settings",
      help: "Help",
      logout: "Logout",
      pos: "POS",
      tickets: "Tickets",
      chatbot: "AI Chatbot",
      catalog: "Catalog",
      module_store: "Module Store",
      ai_assistant: "AI Assistant",
      
      // Navigation groups
      groups: {
        main: "Main",
        sales: "Sales",
        operations: "Operations",
        marketing: "Marketing",
        management: "Management",
        intelligence: "Intelligence",
        team: "Team",
        online_presence: "Online Presence",
        integrations: "Integrations",
      },
      
      // Navigation items - keys must match NavigationConfig.tsx nameKey values
      items: {
        dashboard: "Dashboard",
        moduleStore: "Module Store",
        agenda: "Agenda",
        pos: "POS",
        clients: "Clients",
        chatbotAI: "AI Chatbot",
        aiAssistant: "AI Assistant",
        crm: "CRM",
        quotes: "Quotes",
        contracts: "Contracts",
        subscriptions: "Subscriptions",
        clientPlans: "Client Plans",
        packages: "Packages",
        catalog: "Catalog",
        delivery: "Delivery",
        ecommerce: "E-commerce",
        projects: "Projects",
        reminders: "Reminders",
        inventory: "Inventory",
        checklists: "Checklists",
        tickets: "Tickets",
        passwordPanel: "Password Panel",
        resourceBooking: "Resource Booking",
        fiscalNotes: "Fiscal & Invoices",
        medicalRecords: "Medical Records",
        workouts: "Workouts",
        realEstate: "Real Estate",
        campaigns: "Campaigns",
        whatsappGroups: "WhatsApp Groups",
        automations: "Automations",
        loyalty: "Loyalty",
        nps: "NPS",
        satisfaction: "Satisfaction",
        reviews: "Reviews",
        referrals: "Referrals",
        reactivation: "Reactivation",
        financial: "Financial",
        commissions: "Commissions",
        goals: "Goals",
        reports: "Reports",
        aiPro: "AI Pro",
        leadHunter: "Lead Hunter",
        funnelAnalytics: "Funnel Analytics",
        aiCompetitors: "AI Competitors",
        aiPricing: "AI Pricing",
        aiInsights: "AI Insights",
        aiCopy: "AI Copy",
        communication: "Communication",
        learning: "Learning",
        forms: "Forms",
        library: "Library",
        peopleManagement: "People Management",
        myLinks: "My Links",
        miniSite: "Mini Site",
        clientPortal: "Client Portal",
        webhooks: "Webhooks",
        apiKeys: "API Keys",
        settings: "Settings",
        onlinePresence: "Online Presence",
      },
    },
    
    // Dashboard
    dashboard: {
      welcome: "Hello, {{name}}!",
      summary: "Here's your daily summary.",
      summary_with_appointments: "Here's your daily summary. You have {{count}} appointment(s) today.",
      monthly_revenue: "Monthly Revenue",
      appointments_today: "Today's Appointments",
      pending_tasks: "Pending Tasks",
      active_clients: "Active Clients",
      upcoming_appointments: "Upcoming Appointments",
      recent_transactions: "Recent Transactions",
      transactions: "Transactions",
      no_appointments: "No upcoming appointments",
      create_appointment: "Create appointment",
      new_this_month: "new this month",
      this_month: "this month",
      no_movements: "No recent transactions",
      no_movements_short: "No transactions",
      see_all: "See all",
      quick_actions: "Quick Actions",
      alerts: "Alerts",
      vip_inactive: "VIPs inactive for 30 days",
      pending_leads: "leads awaiting action",
      financial_overview: "Financial Overview",
      no_data_yet: "No data yet",
      add_first_sale: "Add your first sale",
      next_available_time: "Next available time starting from the upcoming hours",
      
      // Stats
      confirmed: "confirmed",
      none: "None",
      
      // Alerts
      top_inactive_clients: "Top Inactive Clients",
      click_to_see_details: "Click to see details",
      pending_leads_count: "Pending Leads",
      click_to_see_pipeline: "Click to see pipeline",
      inactive_clients: "Inactive Clients",
      click_to_reactivate: "Click to reactivate",
      
      // Suggestions
      automatic_suggestions: "Automatic Suggestions",
      reactivate_inactive: "Reactivate Inactive Clients",
      clients_not_buying: "clients haven't purchased in over 30 days",
      inactive_vip_clients: "Inactive VIP Clients",
      vip_need_attention: "VIP clients need attention",
      create_special_coupon: "Create Special Coupon",
      increase_engagement: "Increase engagement with an exclusive offer",
      pending_proposals: "Pending Proposals",
      opportunities_awaiting: "opportunities awaiting follow-up",
      create_campaign: "Create Campaign",
      send_offer: "Send Offer",
      create_coupon: "Create Coupon",
      see_pipeline: "See Pipeline",
      
      // Appointment status
      status: {
        confirmed: "Confirmed",
        scheduled: "Scheduled",
        completed: "Completed",
        cancelled: "Cancelled",
      },
      
      // Client info
      client_not_informed: "Client not informed",
      service_not_informed: "Service not informed",
    },
    
    // Quick Actions
    quick_actions: {
      title: "Quick Actions",
      schedule: "Schedule",
      new_client: "New Client",
      register_sale: "Register Sale",
      send_campaign: "Send Campaign",
      new_appointment: "New Appointment",
      client: "Client",
      service: "Service",
      professional: "Professional",
      date_time: "Date and Time",
      select_client: "Select client",
      select_service: "Select service",
      select_professional: "Select professional",
      client_name: "Client name",
      sale_description: "Sale description",
      register: "Register",
      create: "Create",
      fill_required: "Please fill in all required fields",
      name_required: "Name is required",
      fill_value_description: "Please fill in value and description",
      appointment_created: "Appointment created successfully!",
      appointment_error: "Error creating appointment",
      client_created: "Client registered successfully!",
      client_error: "Error registering client",
      sale_created: "Sale registered successfully!",
      sale_error: "Error registering sale",
    },
    
    // Agenda
    agenda: {
      title: "Agenda",
      subtitle: "Manage your appointments",
      new_appointment: "New Appointment",
      select_client: "Select client",
      select_service: "Select service",
      select_professional: "Select professional",
      select_time: "Select time",
      notes: "Notes",
      day: "Day",
      week: "Week",
      calendar: "Calendar",
      online_booking: "Online Booking",
      waiting_list: "Waiting List",
      widget: "Widget",
      settings: "Settings",
      filter_by_professional: "Filter by professional",
      all_professionals: "All",
      no_appointments_day: "No appointments on this day",
      quick_customer: "Quick Register",
      continue_booking: "Continue with booking",
      customer_name_required: "Customer name is required",
      customer_registered: "Customer registered! Now continue with the booking.",
      fill_required: "Please fill in all required fields",
      appointment_created: "Appointment created successfully!",
      select_professional_confirm: "Please select a professional",
      appointment_details: "Appointment Details",
      send_confirmation: "Send Confirmation",
      confirmation_sent: "Confirmation message sent to {{name}}!",
      reschedule: "Reschedule",
      cancel_appointment: "Cancel Appointment",
      cancel_confirm: "Are you sure you want to cancel this appointment?",
      cancel_irreversible: "This action cannot be undone.",
      keep: "Keep",
      confirm_cancel: "Yes, cancel",
      cancelled_success: "Appointment cancelled!",
      cancellation_sent: "Cancellation message sent to {{name}}!",
      reschedule_appointment: "Reschedule Appointment",
      new_date: "New Date",
      new_time: "New Time",
      confirm_reschedule: "Confirm Reschedule",
      rescheduled_success: "Appointment rescheduled!",
      reschedule_sent: "Reschedule message sent to {{name}}!",
      complete_appointment: "Complete Appointment",
      use_loyalty_points: "Use loyalty points",
      available_points: "{{points}} points available",
      use_cashback: "Use cashback",
      available_cashback: "{{amount}} available",
      confirm_complete: "Confirm and Complete",
      loyalty_redeemed: "Loyalty redeemed!",
      points_used: "{{points}} points used",
      cashback_used: "{{amount}} cashback used",
      meeting_result: "Meeting Result",
      select_outcome: "Select outcome",
      outcome_contact: "Contact made",
      outcome_proposal: "Proposal sent",
      outcome_negotiation: "In negotiation",
      outcome_closed_won: "Closed - Won",
      outcome_closed_lost: "Closed - Lost",
      update_deal: "Update Deal",
      deal_updated: "Deal status updated!",
      copy_link: "Copy Link",
      link_copied: "Link copied!",
      open_meet: "Open Meet",
      status: {
        scheduled: "Scheduled",
        confirmed: "Confirmed",
        completed: "Completed",
        cancelled: "Cancelled",
        no_show: "No show",
      },
      status_updated: "Status updated to {{status}}",
      package_warning: "Package Warning",
      understood: "Understood",
      weekdays: {
        sun: "Sun",
        mon: "Mon",
        tue: "Tue",
        wed: "Wed",
        thu: "Thu",
        fri: "Fri",
        sat: "Sat",
      },
    },
    
    // Clients
    clients: {
      title: "Clients",
      subtitle: "Manage your clients and tags",
      new_client: "New Client",
      edit_client: "Edit Client",
      update_client_desc: "Update client data",
      new_client_desc: "Fill in the data to register a new client",
      total: "Total Clients",
      new_this_month: "New this month",
      average_ticket: "Average Ticket",
      return_rate: "Return Rate",
      name: "Name",
      email: "Email",
      phone: "Phone",
      birthday: "Birthday",
      notes: "Notes",
      tags: "Tags",
      tags_tab: "Tags",
      last_visit: "Last visit",
      total_spent: "Total spent",
      visits: "visits",
      search_placeholder: "Search by name, email or phone...",
      all_tags: "All",
      no_clients: "No clients found",
      try_different_search: "Try a different search",
      register_first_client: "Register your first client to get started",
      client: "Client",
      contact: "Contact",
      loyalty: "Loyalty",
      cpf_cnpj: "Tax ID",
      cpf_cnpj_placeholder: "000.000.000-00 or 00.000.000/0000-00",
      lookup_cnpj: "Lookup Tax ID",
      lookup_cnpj_auto: "Click the icon to lookup tax ID data automatically",
      cpf_cnpj_hint: "Enter tax ID (11 digits) or corporate tax ID (14 digits)",
      invalid_cpf: "Invalid CPF",
      invalid_cnpj: "Invalid CNPJ",
      cpf_cnpj_length_error: "CPF must have 11 digits or CNPJ must have 14 digits",
      enter_valid_cnpj: "Enter a valid CNPJ (14 digits) to lookup",
      select_tags: "Select tags",
      name_required: "Name is required",
      client_updated: "Client updated successfully!",
      client_created: "Client registered successfully!",
      confirm_delete: "Delete client",
      confirm_delete_message: "Are you sure you want to delete {{name}}? This action cannot be undone.",
      client_deleted: "Client deleted successfully!",
      clients_deleted: "{{count}} client(s) deleted",
      send_whatsapp: "Send WhatsApp",
      no_phone: "Client has no phone number registered.",
      no_whatsapp_instance: "No WhatsApp instance connected. Configure in Settings > Integrations.",
      enter_message: "Enter a message.",
      message_sent: "Message sent to {{name}}!",
      error_sending: "Error sending message.",
      view_profile: "View Profile",
      view_details: "View details",
      loyalty_points: "Points",
      cashback: "Cashback",
      history: "History",
      appointments: "Appointments",
      transactions: "Transactions",
      name_placeholder: "Full name",
      notes_placeholder: "Notes about the client",
      no_tags_created: "No tags created. Create tags in the \"Tags\" tab.",
    },
    
    // Finance
    finance: {
      title: "Finance",
      subtitle: "Overview of your cash flow",
      income: "Income",
      income_month: "Income (month)",
      expenses: "Expenses",
      expenses_month: "Expenses (month)",
      balance: "Balance",
      new_transaction: "New Transaction",
      edit_transaction: "Edit Transaction",
      type: "Type",
      amount: "Amount",
      description: "Description",
      category: "Category",
      payment_method: "Payment Method",
      date: "Date",
      due_date: "Due Date",
      status: "Status",
      overview: "Overview",
      dre: "P&L",
      forecast: "AI Forecast",
      income_vs_expenses: "Income vs Expenses",
      recent_transactions: "Recent Transactions",
      no_transactions: "No transactions found",
      no_data: "No data available",
      view_all: "View all",
      view_less: "View less",
      scan_receipt: "Scan Receipt with AI",
      create_transaction: "Create Transaction",
      update_transaction: "Update Transaction",
      confirm_delete: "Delete transaction",
      confirm_delete_message: "Are you sure you want to delete this transaction?",
      transaction_deleted: "Transaction deleted!",
      transaction_updated: "Transaction updated!",
      payment_status: {
        paid: "Paid",
        pending: "Pending",
        overdue: "Overdue",
      },
      categories: {
        service: "Service",
        product: "Product",
        other: "Other",
        supplier: "Supplier",
        rent: "Rent",
        salaries: "Salaries",
        marketing: "Marketing",
        equipment: "Equipment",
      },
      payment_methods: {
        cash: "Cash",
        credit_card: "Credit Card",
        debit_card: "Debit Card",
        pix: "PIX",
        transfer: "Transfer",
        boleto: "Boleto",
      },
    },
    
    // Products/Inventory
    products: {
      title: "Inventory",
      subtitle: "Manage your products and movements",
      new_product: "New Product",
      edit_product: "Edit Product",
      total: "Total",
      active: "Active",
      low_stock: "Low Stock",
      total_value: "Total Value",
      low_stock_alert: "Low Stock Products",
      no_products: "No products found",
      search_placeholder: "Search by name or code...",
      all_categories: "All categories",
      name: "Name",
      sku: "SKU",
      code: "Code",
      category: "Category",
      cost_price: "Cost Price",
      sale_price: "Sale Price",
      stock: "Stock",
      initial_stock: "Initial Stock",
      min_alert: "Min Alert",
      unit: "Unit",
      description: "Description",
      image: "Image",
      visible_catalog: "Visible in Catalog",
      create_product: "Create Product",
      update_product: "Update Product",
      product_created: "Product created successfully!",
      product_updated: "Product updated successfully!",
      product_deleted: "Product deleted successfully!",
      error_creating: "Error creating product",
      error_updating: "Error updating product",
      error_deleting: "Error deleting product",
      entry: "Entry",
      exit: "Exit",
      register_entry: "Register Entry",
      register_exit: "Register Exit",
      movement_history: "Movement History",
      quantity: "Quantity",
      unit_cost: "Unit Cost",
      movement_description: "Description",
      register_movement: "Register",
      entry_registered: "Entry registered!",
      exit_registered: "Exit registered!",
      error_movement: "Error registering movement",
      no_movements: "No movements found",
      units: {
        un: "Unit",
        ml: "Milliliter",
        g: "Gram",
        kg: "Kilogram",
        l: "Liter",
      },
    },
    
    // Marketing
    marketing: {
      title: "Marketing",
      subtitle: "Create campaigns and engage your customers",
      new_campaign: "New Campaign",
      generate_with_ai: "Generate with AI",
      campaign_name: "Campaign Name",
      email_subject: "Email Subject",
      target_audience: "Target Audience",
      message: "Message",
      email: "Email",
      whatsapp: "WhatsApp",
      all_clients: "All clients",
      new_clients: "New clients (last month)",
      birthday_month: "Birthday this month",
      inactive_clients: "Inactive clients (3+ months)",
      by_tags: "By Tags",
      select_tags: "Select Tags",
      no_tags: "No tags created. Create tags in \"Tags\".",
      templates: "Templates",
      use_variables: "Use {nome} for personalization",
      save_draft: "Save Draft",
      schedule: "Schedule",
      send_now: "Send Now",
      all_campaigns: "All",
      email_campaigns: "Email",
      whatsapp_campaigns: "WhatsApp",
      search_campaigns: "Search campaigns...",
      filter_status: "Filter status",
      all_statuses: "All statuses",
      status: {
        sent: "Sent",
        sending: "Sending...",
        scheduled: "Scheduled",
        draft: "Draft",
        failed: "Failed",
      },
      recipients: "recipients",
      no_email_clients: "No clients with email in selected audience",
      no_whatsapp_instance: "No WhatsApp instance connected",
      configure_whatsapp: "Configure an instance in Settings > Integrations",
      no_phone_clients: "No clients with phone in selected audience",
      fill_required: "Fill in required fields",
      fill_email_subject: "Fill in email subject",
      campaign_sent: "Campaign sent to {{count}} client(s)!",
      send_error: "Error sending campaign",
      draft_saved: "Draft saved!",
      campaign_scheduled: "Campaign scheduled!",
      no_campaigns: "No campaigns yet",
      start_first_campaign: "Start by creating your first campaign",
    },
    
    // CRM
    crm: {
      title: "CRM",
      subtitle: "Sales pipeline and opportunities",
      new_opportunity: "New Opportunity",
      ai_insights: "AI Insights",
      lead_scoring: "Lead Scoring",
      manage_stages: "Manage Stages",
      opportunity_title: "Title",
      value: "Value",
      priority: "Priority",
      client: "Client",
      expected_close: "Expected Close",
      description: "Description",
      create_opportunity: "Create Opportunity",
      search_opportunities: "Search opportunities...",
      filter_priority: "Filter priority",
      all_priorities: "All priorities",
      smart_suggestions: "Smart Suggestions",
      inactive_clients_coupon: "inactive clients - Send coupon",
      pending_proposals_reminder: "pending proposals - Remind",
      create_exclusive_package: "Create exclusive Top 10 package",
      open: "Open",
      won: "Won",
      conversion: "Conversion",
      closed_revenue: "Closed Revenue",
      no_opportunities: "No opportunities",
      drag_drop_hint: "Drag cards to move between stages",
      stage_settings: "Stage Settings",
      stage_name: "Stage Name",
      stage_color: "Color",
      add_stage: "Add Stage",
      edit_stage: "Edit Stage",
      delete_stage: "Delete Stage",
      delete_stage_confirm: "Are you sure you want to delete the \"{{name}}\" stage?",
      delete_stage_warning: "Deals in this stage will be moved to \"Lead\".",
      priority_high: "High",
      priority_medium: "Medium",
      priority_low: "Low",
      none: "None",
      select_client: "Select a client",
    },
    
    // Reports
    reports: {
      title: "Reports",
      subtitle: "Business performance analysis",
      export_pdf: "Export PDF",
      exporting: "Exporting...",
      pdf_exported: "PDF exported successfully!",
      pdf_error: "Error exporting PDF",
      new_widget: "New Widget",
      overview: "Overview",
      my_charts: "My Charts",
      financial_report_title: "Financial Report",
      no_widgets: "No widgets created",
      create_widgets_desc: "Create custom charts to track your metrics",
      create_widget: "Create Widget",
      top_clients: "Best Clients",
      visits: "visits",
      total_spent: "total spent",
      monthly_revenue_chart: "Monthly Revenue",
      agenda_analysis: "Complete appointment analysis",
      financial_analysis: "Complete financial analysis",
      marketing_analysis: "Marketing campaign analysis",
      kpis: {
        monthly_revenue: "Monthly Revenue",
        avg_ticket: "Average Ticket",
        today_appointments: "Today's Appointments",
        completed: "completed",
        total_clients: "Total Clients",
        new: "new",
        monthly_expenses: "Monthly Expenses",
        net_profit: "Net Profit",
        positive: "Positive",
        negative: "Negative",
      },
      charts: {
        monthly_revenue: "Monthly Revenue",
        best_clients: "Best Clients",
        no_clients: "No clients registered",
        visits: "visits",
        total_spent: "total spent",
      },
      report_types: {
        agenda: "Agenda Report",
        agenda_desc: "Occupancy rate, peak hours and no-shows.",
        financial: "Financial Report",
        financial_desc: "P&L, cash flow and expense analysis.",
        marketing: "Marketing Report",
        marketing_desc: "Campaigns sent, open rates and conversions.",
      },
      agenda_report: {
        title: "Agenda Report",
        description: "Complete appointment analysis",
        total_appointments: "Total Appointments",
        occupancy_rate: "Occupancy Rate",
        cancellations: "Cancellations",
        no_show: "No Show",
        completed: "Completed",
        cancelled: "Cancelled",
        status_distribution: "Status Distribution",
      },
      financial_report: {
        title: "Financial Report",
        description: "Cash flow and detailed analysis",
        income: "Income",
        expenses: "Expenses",
        balance: "Balance",
        cash_flow: "Cash Flow",
        expense_breakdown: "Expense Breakdown",
      },
      marketing_report: {
        title: "Marketing Report",
        description: "Campaign performance",
        total_campaigns: "Campaigns Sent",
        total_recipients: "Total Recipients",
        open_rate: "Open Rate",
        click_rate: "Click Rate",
        campaign_performance: "Campaign Performance",
        opened: "Opened",
        clicked: "Clicked",
      },
    },
    
    // Loyalty
    loyalty: {
      title: "Loyalty",
      subtitle: "Points program, cashback and coupons",
      points_issued: "Points Issued",
      available_cashback: "Available Cashback",
      active_coupons: "Active Coupons",
      config: "Settings",
      coupons: "Coupons",
      customers: "Customers",
      loyalty_program: "Loyalty Program",
      program_rules: "Configure points and cashback rules",
      program_active: "Program Active",
      program_active_desc: "Enable or disable the loyalty program",
      points_per_currency: "Points per $1.00",
      points_per_currency_hint: "Ex: 0.1 = 1 point every $10.00",
      cashback_percent: "Cashback (%)",
      cashback_percent_hint: "Cashback percentage on purchases",
      expiration_days: "Points Expiration (days)",
      expiration_days_hint: "Leave empty for no expiration",
      never_expires: "Never expires",
      save_config: "Save Settings",
      search_coupon: "Search coupon...",
      all: "All",
      active: "Active",
      expired: "Expired",
      exhausted: "Exhausted",
      inactive: "Inactive",
      new_coupon: "New Coupon",
      create_coupon: "Create Coupon",
      code: "Code",
      generate: "Generate",
      discount_type: "Discount Type",
      percent: "Percentage (%)",
      fixed: "Fixed Value ($)",
      discount_value: "Value",
      min_amount: "Minimum Amount ($)",
      max_uses: "Maximum Uses",
      unlimited: "Unlimited",
      valid_until: "Valid Until",
      no_coupons: "No coupons created",
      no_coupons_found: "No coupons found",
      code_required: "Enter the coupon code",
      code_copied: "Code copied!",
      uses: "uses",
      clients_with_loyalty: "Clients with Loyalty",
      search_client: "Search client...",
      points: "Points",
      cashback: "Cashback",
      no_clients_loyalty: "No clients have accumulated points or cashback yet.",
    },
    
    // Settings
    settings: {
      title: "Settings",
      subtitle: "Manage your business settings",
      business: "Business",
      services: "Services",
      team: "Team",
      integrations: "Integrations",
      notifications: "Notifications",
      billing: "Billing",
      units: "Units",
      
      // Language
      language: "Language",
      language_title: "System Language",
      language_description: "Choose the interface language",
      
      // Profile
      profile_photo: "Profile Photo",
      profile_photo_desc: "This photo will be displayed in internal communication and your profile",
      change_photo: "Change photo",
      uploading: "Uploading...",
      
      // Business
      business_data: "Business Data",
      business_data_desc: "Information shown to your customers",
      business_name: "Business Name",
      phone_with_ddi: "Phone (with country code)",
      address: "Address",
      address_placeholder: "Street, number, neighborhood, city - State",
      cnpj: "Tax ID",
      slug: "Custom link",
      slug_desc: "This slug will be used in public URLs for catalog, booking and linktree",
      save_data: "Save Changes",
      public_url: "Public URL",
      
      // Hours
      hours: "Hours",
      hours_title: "Business Hours",
      hours_desc: "Configure your working days and hours",
      start_time: "Start",
      end_time: "End",
      working_days: "Working Days",
      save_hours: "Save Hours",
      
      // Weekdays
      weekdays: {
        sun: "Sun",
        mon: "Mon",
        tue: "Tue",
        wed: "Wed",
        thu: "Thu",
        fri: "Fri",
        sat: "Sat",
      },
      
      // Notifications
      push_notifications: "Push Notifications",
      push_notifications_desc: "Receive appointment reminders directly in your browser",
      notifications_active: "Notifications active",
      notifications_active_desc: "You will receive appointment reminders",
      notifications_blocked: "Notifications have been blocked by your browser. To enable, go to your browser settings → Privacy and security → Site settings → Notifications, and allow notifications for this site.",
      notifications_not_supported: "Your browser does not support push notifications",
      notifications_not_supported_desc: "To receive notifications, use a modern browser like Chrome, Firefox, Edge or Safari.",
      enable_notifications: "Enable Notifications",
      reminder_15min: "Reminder 15 min before",
      reminder_30min: "Reminder 30 min before",
      new_appointments_notif: "New appointments",
      
      // Email notifications
      email_notifications: "Email Notifications",
      email_notifications_desc: "Configure the notifications you receive by email",
      email_new_appointments: "New appointment emails",
      email_new_appointments_desc: "Receive when a client books",
      appointment_reminders: "Appointment reminders",
      appointment_reminders_desc: "Alert 15min before the appointment",
      weekly_report: "Weekly report",
      weekly_report_desc: "Performance summary every Monday",
      low_stock_alerts: "Low stock alerts",
      low_stock_alerts_desc: "When products are running out",
      save_notifications: "Save Notifications",
    },
    
    // Auth
    auth: {
      login: "Login",
      register: "Create Account",
      logout: "Logout",
      email: "Email",
      password: "Password",
      confirm_password: "Confirm Password",
      forgot_password: "Forgot password?",
      reset_password: "Reset Password",
      full_name: "Full Name",
      already_have_account: "Already have an account?",
      dont_have_account: "Don't have an account?",
      or_continue_with: "or continue with",
      logging_in: "Logging in...",
      creating_account: "Creating account...",
    },
    
    // Languages
    languages: {
      pt: "Português",
      en: "English",
      es: "Español",
    },
    
    // Errors
    errors: {
      generic: "An error occurred. Please try again.",
      required_field: "This field is required",
      invalid_email: "Invalid email",
      invalid_phone: "Invalid phone",
      photo_update_error: "Error updating photo",
    },
    
    // Success messages
    success: {
      saved: "Saved successfully!",
      deleted: "Deleted successfully!",
      updated: "Updated successfully!",
      photo_updated: "Profile photo updated!",
      hours_saved: "Hours saved successfully!",
      notifications_saved: "Notification preferences saved!",
    },

    // Changelog
    changelog: {
      title: "What's New",
      loading: "Loading...",
      no_updates: "No updates available",
      new: "New",
      improvement: "Improvement",
      fix: "Fix",
    },

    // Insights
    insights: {
      title: "AI Insights",
      subtitle: "Intelligent analysis and suggestions for your business",
      generate: "Generate Insights",
      analyzing: "Analyzing...",
      active_insights: "Active Insights",
      high_priority: "High Priority",
      about_revenue: "About Revenue",
      dismissed: "Dismissed",
      search_placeholder: "Search insights...",
      filter_type: "Type",
      filter_priority: "Priority",
      all_types: "All types",
      revenue: "Revenue",
      customers: "Customers",
      appointments: "Appointments",
      inventory: "Inventory",
      alerts: "Alerts",
      all_priorities: "All",
      high: "High",
      medium: "Medium",
      low: "Low",
      loading: "Loading insights...",
      no_insights: "No insights available",
      no_insights_found: "No insights found",
      no_insights_desc: "Click \"Generate Insights\" for the AI to analyze your data and suggest improvements for your business.",
      adjust_filters: "Try adjusting the filters",
      dismiss_insight: "Dismiss insight",
      generated_at: "Generated at",
      dismissed_insights: "Dismissed Insights",
    },

    // PDV
    pdv: {
      title: "POS",
      subtitle: "Quick point of sale",
      quick_sale: "Quick Sale",
      tables: "Tables",
      wristbands: "Wristbands",
      cash_open: "Cash Open",
      open_cash: "Open Cash",
      quick_links: "Quick Links:",
      waiter_tables: "Waiter - Tables",
      waiter_wristbands: "Waiter - Wristbands",
      security: "Security",
      kitchen: "Kitchen",
      search_placeholder: "Search product or service...",
      products: "Products",
      services: "Services",
      all: "All",
      no_items: "No items found",
      out_of_stock: "Product out of stock",
      insufficient_stock: "Insufficient stock",
      max_available: "Maximum available quantity",
      cart: "Cart",
      customer: "Customer (optional)",
      no_customer: "No customer",
      select_customer: "Select customer",
      search_customer: "Search customer...",
      no_customer_found: "No customer found.",
      empty_cart: "Empty cart",
      discount: "Discount",
      payment_method: "Payment method",
      cash: "Cash",
      credit_card: "Credit Card",
      debit_card: "Debit Card",
      pix: "PIX",
      subtotal: "Subtotal",
      total: "Total",
      finalize_sale: "Finalize Sale",
      processing: "Processing...",
      sale_completed: "Sale Completed!",
      no_sku: "No SKU",
      without_stock: "Out of stock",
    },

    // Clinic
    clinic: {
      title: "Clinic",
      subtitle: "Electronic medical records, anamnesis and clinical evolution",
      patients: "Patients",
      records: "Medical Records",
      evolutions: "Evolutions",
      photos: "Photos",
      search_patient: "Search patient...",
      no_patients: "No patients found",
      record: "Medical Record",
      last_appointment: "Last appointment",
      no_contact: "No contact",
      select_patient: "Select a patient to view the medical record",
      new_anamnesis: "New Anamnesis",
      new_evolution: "New Evolution",
      suggest_treatment: "Suggest Treatment",
      anamnesis: "Anamnesis",
      prescription: "Prescription",
      evolution: "Evolution",
      exam: "Exam",
      consent: "Consent",
      chief_complaint: "Chief Complaint",
      chief_complaint_placeholder: "Describe the patient's chief complaint...",
      medical_history: "Medical History",
      medical_history_placeholder: "Previous diseases, surgeries, hospitalizations...",
      allergies: "Allergies",
      allergies_placeholder: "Medications, food, others...",
      medications: "Current Medications",
      medications_placeholder: "List the medications...",
      family_history: "Family History",
      family_history_placeholder: "Family diseases...",
      lifestyle: "Habits and Lifestyle",
      lifestyle_placeholder: "Smoking, alcohol, physical activity...",
      save_anamnesis: "Save Anamnesis",
      ai_suggestion: "AI Suggestion",
      not_informed: "Not informed",
      appointments_count: "Appointments",
      records_count: "Records",
      clinical_history: "Clinical History",
      no_records: "No records found",
      no_records_desc: "Create an anamnesis or evolution to start",
      appointment: "Appointment",
      no_notes: "No notes recorded",
      see_details: "See Details",
      clinical_evolutions: "Clinical Evolutions",
      select_patient_evolutions: "Select a patient and record evolutions",
      evolution_photos: "Evolution Photos",
      add_photo: "Add Photo",
      no_photos: "No evolution photos recorded",
      no_photos_desc: "Add before/after photos to track treatment evolution",
      new_clinical_evolution: "New Clinical Evolution",
      patient: "Patient",
      select_patient_form: "Select the patient...",
      title_field: "Title",
      title_placeholder: "Ex: Follow-up - Evaluation",
      evolution_field: "Evolution",
      evolution_placeholder: "Describe the patient's evolution...",
      save_evolution: "Save Evolution",
      ai_suggestion_title: "AI Suggestion",
      select_patient_first: "Select a patient first.",
      ai_error: "Error processing AI suggestion.",
    },

    // Header
    header: {
      notifications: "Notifications",
      mark_all: "Mark all",
      no_notifications: "No notifications",
      search_placeholder: "Search... (Ctrl+K)",
      expand_menu: "Expand menu",
      collapse_menu: "Collapse menu",
      my_profile: "My Profile",
      subscription: "Subscription",
      admin_panel: "Admin Panel",
      help_center: "Help Center",
      support: "Support",
      logout: "Logout",
    },

    // Quick Replies (Chatbot)
    quick_replies: {
      title: "Quick Replies",
      description: "Configure pre-defined messages to speed up service",
      new_reply: "New Reply",
      edit_reply: "Edit Quick Reply",
      title_shortcut: "Title (shortcut)",
      title_placeholder: "Ex: Greeting, Thank you, Hours...",
      title_help: "A short name to identify the reply",
      message: "Message",
      message_placeholder: "Ex: Hello! Thanks for reaching out. How can I help?",
      message_help: "The complete message that will be sent",
      saving: "Saving...",
      no_replies: "No quick replies created",
      no_replies_desc: "Create replies to speed up your service",
      confirm_delete: "Are you sure you want to delete this quick reply?",
      title_message_required: "Title and message are required",
    },

    // Agenda Banners
    agenda_banners: {
      title: "Agenda Banners",
      description: "Add promotional banners to be displayed on the agenda page",
      add: "Add",
      edit_banner: "Edit Banner",
      title_optional: "Title (optional)",
      title_placeholder: "Ex: Summer Sale",
      link_optional: "Link (optional)",
      apply: "Apply",
      save_banners: "Save Banners",
      image_uploaded: "Image uploaded! Save to apply.",
      upload_error: "Upload error",
    },

    // PDV Tables
    pdv_tables: {
      table: "Table",
      tables: "Tables",
      manage_tables: "Manage Tables",
      new_table: "New Table",
      create_table: "Create Table",
      table_number: "Table Number",
      table_name: "Name (optional)",
      capacity: "Capacity",
      people: "people",
      available: "Available",
      occupied: "Occupied",
      reserved: "Reserved",
      open_table: "Open Table",
      close_table: "Close Table",
      table_closed: "Table Closed!",
      back: "Back",
      opened: "Opened",
      order: "Order",
      no_items: "No items",
      search_item: "Search item...",
      products: "Products",
      services: "Services",
      qr_codes: "QR Codes",
      download_qr: "Download QR",
      print_all: "Print All",
      customer: "Customer",
      search_customer: "Search customer...",
      no_customer_found: "No customer found",
      new_customer: "New Customer",
      register_customer: "Register Customer",
      name_required: "Name is required",
      customer_registered: "Customer registered!",
      customer_error: "Error registering customer",
      confirm_open: "Confirm Opening",
      no_tables: "No tables registered",
      create_first_table: "Create the first table",
      delete_confirm: "Delete table",
    },

    // Cash Register
    cash_register: {
      title: "Cash Register",
      description: "Manage opening, closing and cash movements",
      current: "Current",
      movements: "Movements",
      history: "History",
      open_register: "Open Register",
      close_register: "Close Register",
      opening_amount: "Opening Amount",
      closing_amount: "Cash Amount",
      observations: "Notes",
      observations_open: "Notes about opening...",
      observations_close: "Notes about closing...",
      opening: "Opening",
      inflows: "Inflows",
      outflows: "Outflows",
      expected_balance: "Expected Balance",
      opened_at: "Opened at",
      difference: "Difference",
      new_movement: "New Movement",
      sangria: "Withdrawal",
      suprimento: "Supply",
      amount: "Amount",
      movement_description: "Description",
      movement_placeholder: "Reason for movement...",
      register_sangria: "Register Withdrawal",
      register_suprimento: "Register Supply",
      daily_movements: "Daily Movements",
      no_movements: "No movements recorded",
      sale: "Sale",
      refund: "Refund",
      open_to_register: "Open register to record movements",
      date_from: "From",
      date_to: "To",
      clear: "Clear",
      no_history: "No register records found",
      no_history_period: "No records found for this period",
      open: "Open",
      closed: "Closed",
      closing: "Closing",
      register_opened: "Register opened successfully!",
      register_closed: "Register closed successfully!",
      movement_registered: "registered!",
      error_open: "Error opening register",
      error_close: "Error closing register",
      error_movement: "Error registering movement",
      details: "Register Details",
      copy: "Copy",
      whatsapp: "WhatsApp",
      expected_value: "Expected Value",
      counted_value: "Counted Value",
      balanced: "✓ Register balanced!",
      number_not_configured: "Number not configured",
      configure_whatsapp: "Configure WhatsApp number in business settings",
      report_sent: "Report sent via WhatsApp!",
      send_error: "Error sending",
      send_error_desc: "Could not send report via WhatsApp",
      report_copied: "Report copied!",
      products_sold: "Products Sold",
      financial_summary: "Financial Summary",
      sales_by_payment: "Sales by Payment Method",
      totals: "Totals",
      gross_revenue: "Gross Revenue",
      product_cost: "Product Cost",
      gross_profit: "Gross Profit",
      sales_suprim: "Sales + Supplies",
      sangria_refund: "Withdrawals + Refunds",
      no_movement: "No movements",
    },

    // Wristbands
    wristbands: {
      title: "Wristbands",
      active_wristbands: "Active Wristbands",
      new: "New",
      no_active: "No active wristbands",
      wristband: "Wristband",
      cancel: "Cancel",
      close: "Close",
      search_product_service: "Search product or service...",
      consumption: "Consumption",
      no_items: "No items added",
      select_wristband: "Select a wristband",
      select_wristband_desc: "Click on an active wristband or create a new one",
      new_wristband: "New Wristband",
      wristband_code: "Wristband Code *",
      code_placeholder: "Ex: A001, 123, etc",
      customer: "Customer",
      search_customer: "Search by name, phone or ID...",
      no_customer_found: "No customer found",
      register_new: "Register New",
      create_wristband: "Create Wristband",
      quick_customer: "Quick Customer Registration",
      name_required: "Name *",
      customer_name: "Customer name",
      phone: "Phone",
      cpf: "ID Number",
      birth_date: "Birth Date",
      register_select: "Register and Select",
      close_wristband: "Close Wristband",
      subtotal: "Subtotal",
      discount: "Discount",
      payment_method: "Payment Method",
      cash: "Cash",
      credit: "Credit Card",
      debit: "Debit Card",
      pix: "PIX",
      no_register_warning: "⚠️ No register open. Payment will be recorded but won't enter cash control.",
      confirm_payment: "Confirm Payment",
      wristband_created: "Wristband created!",
      wristband_closed: "Wristband closed successfully!",
      wristband_cancelled: "Wristband cancelled",
      item_added: "added!",
      error_create: "Error creating wristband",
      error_add_item: "Error adding item",
      error_close: "Error closing wristband",
      error_cancel: "Error cancelling",
      customer_registered: "Customer registered!",
      error_customer: "Error registering customer",
      enter_name: "Enter customer name",
      enter_code: "Enter wristband code",
      discount_exceed: "Discount cannot exceed total",
    },

    // Chat
    chat: {
      emojis: "Emojis",
      image: "Image",
      document: "Document",
      video: "Video",
      quick_replies_click: "Quick Replies (click to send)",
      recording: "Recording",
      type_message: "Type your message...",
      microphone_error: "Could not access microphone",
      contact_details: "Contact Details",
      whatsapp_contact: "WhatsApp Contact",
      registered_customer: "Registered customer",
      contact_only: "Contact only",
      visits: "Visits",
      total_spent: "Total spent",
      view_full_details: "View Full Details",
      create_lead: "Create Lead / Customer",
      name_required: "Name is required",
      customer_name: "Customer name",
      lead_notes: "Notes about the lead...",
      create_lead_button: "Create Lead",
      conversation_tags: "Conversation Tags",
      tags_description: "Create custom tags to organize your conversations",
      new_tag: "New Tag",
      edit_tag: "Edit Tag",
      tag_name: "Tag Name",
      tag_placeholder: "E.g.: Urgent, VIP, New Customer...",
      tag_name_required: "Tag name is required",
      no_tags: "No tags created",
      create_tags_organize: "Create tags to organize your conversations",
    },

    // Medical Records
    medical_records: {
      title: "Electronic Medical Records",
      subtitle: "Anamnesis, clinical evolution and patient history",
      patients: "Patients",
      records: "Records",
      evolutions: "Evolutions",
      photos: "Photos",
      search_patient: "Search patient...",
      no_patient_found: "No patient found",
      no_patients: "No patients found",
      no_contact: "No contact",
      record: "Record",
      select_patient_to_view: "Select a patient to view the record",
      medications_in_use: "Current Medications",
      select_patient_first: "Select a patient first.",
      fill_chief_complaint: "Fill in the chief complaint.",
      fill_evolution_content: "Fill in the evolution content.",
      select_photo: "Select a photo.",
      new_anamnesis: "New Anamnesis",
      anamnesis: "Anamnesis",
      chief_complaint: "Chief Complaint",
      chief_complaint_placeholder: "Describe the patient's chief complaint...",
      medical_history: "Medical History",
      medical_history_placeholder: "Previous diseases, surgeries, hospitalizations...",
      allergies: "Allergies",
      allergies_placeholder: "Medications, food, others...",
      medications: "Current Medications",
      medications_placeholder: "List the medications...",
      family_history: "Family History",
      family_history_placeholder: "Family diseases...",
      lifestyle: "Lifestyle",
      lifestyle_placeholder: "Habits, physical activities...",
      save_anamnesis: "Save Anamnesis",
      ai_suggestion: "AI Suggestion",
      new_evolution: "New Evolution",
      clinical_evolution: "Clinical Evolution",
      evolution: "Evolution",
      evolution_placeholder: "Describe the patient's evolution...",
      diagnosis: "Diagnosis",
      diagnosis_placeholder: "Diagnosis or diagnostic hypothesis...",
      treatment: "Treatment",
      treatment_placeholder: "Treatment plan...",
      observations: "Observations",
      observations_placeholder: "Additional observations...",
      save_evolution: "Save Evolution",
      add_photo: "Add Photo",
      upload_photo: "Photo Upload",
      select_file: "Select a file",
      photo_description: "Description",
      photo_description_placeholder: "Photo description...",
      photo_category: "Category",
      category_placeholder: "Ex: Before, After, Exam...",
      upload: "Upload",
      select_patient_record: "Select a patient to view the record",
      anamnesis_history: "Anamnesis History",
      no_anamnesis: "No anamnesis registered",
      evolutions_history: "Clinical Evolutions",
      no_evolutions: "No evolutions registered",
      photo_gallery: "Photo Gallery",
      no_photos: "No photos registered",
      delete_photo: "Delete Photo",
      delete_photo_confirm: "Are you sure you want to delete this photo?",
      ai_suggestion_title: "AI Suggestion",
      ai_error: "Error processing AI suggestion.",
    },

    // Contracts
    contracts: {
      title: "Contracts",
      new_template: "New Template",
      new_contract: "New Contract",
      create_template: "Create Contract Template",
      template_name: "Template name",
      template_content: "Contract content. Use {{client_name}}, {{client_email}}, {{current_date}} as placeholders.",
      create_template_btn: "Create Template",
      generate_contract: "Generate Contract",
      edit_contract: "Edit Contract",
      select_client: "Select the client",
      search_client: "Search client...",
      no_client_found: "No client found.",
      select_template: "Select a template (optional)",
      search_template: "Search template...",
      no_template_found: "No template found.",
      contract_content: "Contract content",
      save_changes: "Save Changes",
      create_contract_btn: "Create Contract",
      total: "Total",
      drafts: "Drafts",
      sent: "Sent",
      signed: "Signed",
      contracts_tab: "Contracts",
      templates_tab: "Templates",
      search_by_client: "Search by client...",
      all_status: "All status",
      draft: "Draft",
      cancelled: "Cancelled",
      loading: "Loading...",
      no_contracts: "No contracts found",
      created_at: "Created on",
      signed_at: "Signed on",
      copy_link: "Copy Link",
      open_link: "Open Link",
      no_templates: "No templates created",
      contract_details: "Contract Details",
      close: "Close",
      print: "Print",
      share: "Share",
      send_signature: "Send for Signature",
      signature_pending: "Signature Pending",
      delete_contract: "Delete Contract",
      delete_contract_confirm: "Are you sure you want to delete this contract?",
      delete_template: "Delete Template",
      delete_template_confirm: "Are you sure you want to delete this template?",
      link_copied: "Link copied!",
      client: "Client",
      signer_ip: "Signer IP",
      share_contract: "Share Contract",
      no_contract_found: "No contract found",
      no_template_found_msg: "No template found",
      status: {
        draft: "Draft",
        sent: "Sent",
        signed: "Signed",
        cancelled: "Cancelled",
      },
    },

    // Training
    training: {
      title: "Training",
      subtitle: "Team training and development",
      new_course: "New Course",
      create_course: "Create New Course",
      course_title: "Title",
      course_name: "Course name",
      course_description: "Description",
      course_description_placeholder: "Course description",
      create_course_btn: "Create Course",
      courses: "Courses",
      in_progress: "In progress",
      completed: "Completed",
      pending: "Pending",
      search_course: "Search course...",
      all: "All",
      enrolled: "Enrolled",
      not_enrolled: "Not enrolled",
      loading: "Loading...",
      no_courses: "No courses created",
      no_courses_found: "No courses found",
      no_description: "No description",
      select_course: "Select a course",
      select_course_desc: "Select a course to view and edit content",
      module: "Module",
      add_module: "Add Module",
      module_title: "Module Title",
      module_title_placeholder: "Ex: Introduction",
      module_description: "Description",
      module_description_placeholder: "Module description",
      create_module_btn: "Create Module",
      no_modules: "No modules created",
      add_module_tip: "Click \"Module\" to add content",
      add_lesson: "Add Lesson",
      lesson_title: "Lesson Title",
      lesson_title_placeholder: "Ex: Welcome",
      lesson_content: "Content",
      lesson_content_placeholder: "Lesson content...",
      video_url: "Video URL (optional)",
      duration: "Duration (min)",
      create_lesson_btn: "Create Lesson",
      no_lessons: "Add lessons to the module",
      enroll: "Enroll",
      enrollment: "Enrollment",
      status: {
        completed: "Completed",
        in_progress: "In progress",
        not_started: "Not started",
      },
      module_created: "Module created!",
      lesson_created: "Lesson created!",
      module_deleted: "Module deleted!",
      lesson_deleted: "Lesson deleted!",
    },

    // Forms
    forms: {
      title: "Forms",
      subtitle: "Create custom forms for data collection",
      new_form: "New Form",
      create_form: "Create Form",
      form_config: "Configure new form options",
      form_name: "Name",
      form_name_placeholder: "Ex: Anamnesis Form",
      form_description: "Description",
      form_description_placeholder: "Form description",
      form_type: "Type",
      type_generic: "Generic",
      type_pre_attendance: "Pre-Attendance",
      type_survey: "Survey",
      expiration_date: "Expiration Date (optional)",
      allow_image: "Allow image upload",
      capture_location: "Capture location",
      creating: "Creating...",
      create_btn: "Create",
      forms: "Forms",
      forms_count: "Forms",
      active: "Active",
      responses: "Responses",
      your_forms: "Your Forms",
      search: "Search...",
      type: "Type",
      all_types: "All types",
      all: "All",
      all_status: "All",
      generic: "Generic",
      pre_attendance: "Pre-Attendance",
      survey: "Survey",
      active_only: "Active",
      inactive: "Inactive",
      inactive_only: "Inactive",
      loading: "Loading...",
      no_forms: "No forms created",
      no_forms_found: "No forms found",
      no_description: "No description",
      expires: "Expires",
      fields: "Fields",
      responses_tab: "Responses",
      add_field: "Add Field",
      field_label: "Field name",
      field_label_placeholder: "Field name",
      field_type: "Type",
      type_text: "Text",
      type_number: "Number",
      type_boolean: "Yes/No",
      type_select: "Selection",
      add_btn: "Add",
      no_fields: "No fields added",
      settings: "Settings",
      copy_link: "Copy Link",
      open_link: "Open Link",
      toggle_status: "Toggle Status",
      delete_form: "Delete",
      select_form: "Select a form",
      select_form_desc: "Select a form on the left to view or edit",
      options_modal: "Field Options",
      options_modal_desc: "Add options for this selection field",
      option_placeholder: "New option",
      add_option: "Add",
      confirm_options: "Confirm Options",
      add_at_least_one: "Add at least one option",
      form_settings: "Form Settings",
      form_settings_desc: "Adjust advanced form settings",
      save_settings: "Save Settings",
      link_copied: "Link copied!",
    },

    // Customer Plans
    customer_plans: {
      title: "Customer Plans",
      subtitle: "Manage recurring plans for your customers",
      new_plan: "New Plan",
      subscribe_client: "Subscribe Customer",
      create_plan: "Create Plan",
      plan_name: "Plan name",
      plan_name_placeholder: "Ex: Premium Monthly Plan",
      plan_description: "What's included...",
      plan_value: "Value",
      periodicity: "Periodicity",
      monthly: "Monthly",
      yearly: "Yearly",
      create_plan_btn: "Create Plan",
      subscribe_plan: "Subscribe Customer to Plan",
      client: "Customer",
      select_client: "Select the customer",
      search_client: "Search customer...",
      no_client_found: "No customer found.",
      plan: "Plan",
      select_plan: "Select the plan",
      search_plan: "Search plan...",
      no_plan_found: "No plan found.",
      start_date: "Start date",
      subscribe_btn: "Subscribe",
      total: "Total",
      active: "Active",
      expiring: "Expiring",
      overdue: "Overdue",
      subscriptions: "Subscriptions",
      plans: "Plans",
      search: "Search by customer or plan...",
      all: "All",
      active_only: "Active",
      expiring_only: "Expiring",
      overdue_only: "Overdue",
      cancelled: "Cancelled",
      loading: "Loading...",
      no_subscriptions: "No subscriptions",
      no_subscriptions_found: "No subscriptions found",
      subscribe_clients: "Subscribe customers to plans",
      adjust_filters: "Try adjusting the filters",
      try_filters: "Try adjusting the filters",
      start: "Start",
      next_due: "Next due",
      send_email_reminder: "Send email reminder",
      send_whatsapp_reminder: "Send WhatsApp reminder",
      cancel_subscription: "Cancel",
      reactivate: "Reactivate",
      status: {
        active: "Active",
        cancelled: "Cancelled",
        overdue: "Overdue",
        expiring: "Expires in {{days}} days",
      },
      per_month: "month",
      per_year: "year",
      no_plans: "No plans created",
      create_first: "Create plans to subscribe customers",
      edit_plan: "Edit",
      deactivate_plan: "Deactivate",
      activate_plan: "Activate",
      email_reminder_sent: "Email reminder sent",
      email_reminder_desc: "Email sent to {{name}} about plan {{plan}}",
    },

    // Team
    team: {
      title: "Team",
      description: "Manage members with access and agenda professionals",
      with_access: "With Access",
      pending: "Pending",
      agenda_only: "Agenda Only",
      invite_member: "Invite Member",
      no_members: "No team members",
      invite_desc: "Invite members to give system access",
      linked_agenda: "Linked to agenda",
      make_admin: "Make Admin",
      make_staff: "Make Staff",
      remove: "Remove",
      no_pending: "No pending invitations",
      expires_at: "Expires on",
      professionals_desc: "Professionals who appear in the agenda but don't have system access. To give access, invite them in the \"With Access\" tab.",
      new_professional: "New Professional",
      edit_professional: "Edit Professional",
      full_name: "Full name",
      registration: "Registration",
      employee_code: "Employee code",
      role: "Role",
      role_placeholder: "Ex: Hairdresser, Manicurist",
      commission: "Commission (%)",
      professional_active: "Professional active",
      create_professional: "Create Professional",
      no_professionals: "No professionals registered",
      register_desc: "Register professionals to use in the agenda",
      no_role: "No role",
      commission_suffix: "commission",
      invite_new: "Invite New Member",
      permission: "Permission",
      staff_default: "Staff (default)",
      admin: "Administrator",
      permission_desc: "Staff have limited access. Admins have full access.",
      send_invite: "Send Invitation",
      remove_member: "Remove member",
      remove_confirm: "Are you sure you want to remove this team member? They will lose system access.",
      remove_btn: "Remove",
      owner: "Owner",
      updated: "Professional updated!",
      created: "Professional created!",
      error_update: "Error updating professional",
      name_required: "Name is required",
      inactive: "Inactive",
    },

    // API Keys
    api_keys: {
      title: "API Keys",
      description: "Manage your API keys for integration",
      new_key: "New Key",
      create_key: "Create Key",
      key_name: "Key Name",
      key_name_placeholder: "Ex: ERP Integration",
      key_created: "Key created successfully!",
      key_deleted: "Key deleted successfully",
      copy_key: "Copy Key",
      key_copied: "Key copied!",
      show_key: "Show Key",
      hide_key: "Hide Key",
      last_used: "Last used",
      never_used: "Never used",
      delete_confirm: "Are you sure you want to delete this key?",
      delete_warning: "This action cannot be undone. Integrations using this key will stop working.",
      active: "Active",
      inactive: "Inactive",
      error_create: "Error creating key",
      error_delete: "Error deleting key",
      name_required: "Enter a name for the key",
      business_not_found: "Business not found",
      keys_tab: "My Keys",
      docs_tab: "Documentation",
      playground_tab: "Playground",
      no_keys: "No API keys created",
      create_first: "Create your first key to start integrating",
      warning_copy: "Copy your key now. It won't be displayed again!",
      endpoints: "Endpoints",
      test: "Test",
      testing: "Testing...",
      select_key: "Select a key",
      authentication: "Authentication",
      auth_description: "Use your API key in the Authorization header:",
      prefix: "Prefix",
      copy_code: "Copy code",
      params: "Parameters",
      body_example: "Body (example)",
      playground_description: "Test API endpoints directly in the browser",
      create_to_test: "Create an API key to test the endpoints",
    },

    // Chatbot Knowledge
    chatbot_knowledge: {
      title: "Knowledge Base",
      description: "Train the chatbot with documents and FAQs",
      documents_tab: "Documents",
      qa_tab: "Questions & Answers",
      add_document: "Add Document",
      document_name: "Document Name",
      document_name_placeholder: "Ex: Cancellation Policy",
      document_content: "Content",
      document_content_placeholder: "Paste here the document content that the chatbot should know...",
      saving: "Saving...",
      save_document: "Save Document",
      no_documents: "No documents added",
      no_documents_desc: "Add documents such as policies, rules, service information, etc.",
      added_at: "Added on",
      add_question: "Add Question",
      add_qa: "Add Question and Answer",
      question: "Question",
      question_placeholder: "Ex: What are the business hours?",
      answer: "Answer",
      answer_placeholder: "Ex: We are open Monday to Friday, from 8am to 6pm.",
      save: "Save",
      no_questions: "No questions added",
      no_questions_desc: "Add frequently asked questions and their answers for quick chatbot responses",
      documents_helper: "Add documents for the chatbot to consult during conversations",
      qa_helper: "Add frequently asked questions for quick and accurate responses",
    },

    // Staff
    staff: {
      title: "Professionals",
      description: "Manage professionals who provide services",
      new_professional: "New Professional",
      edit_professional: "Edit Professional",
      name: "Name",
      name_required: "Name is required",
      full_name: "Full name",
      email: "Email",
      phone: "Phone",
      registration: "Registration",
      employee_code: "Employee code",
      cpf: "Tax ID",
      role: "Role",
      role_placeholder: "Ex: Hairdresser, Manicurist",
      commission: "Commission (%)",
      professional_active: "Professional active",
      save: "Save",
      create: "Create Professional",
      updated: "Professional updated!",
      created: "Professional created!",
      error_update: "Error updating professional",
      no_professionals: "No professionals registered",
      no_role: "No role",
      commission_suffix: "commission",
      inactive: "Inactive",
    },

    // Linktree / Bio Page
    linktree: {
      title: "Bio Page",
      description: "Your professional link page",
      create_page: "Create your Bio Page",
      slug_not_configured: "Slug not configured",
      slug_config_hint: "Configure a slug in Settings → Business Data to create your Bio Page.",
      page_url: "Your page URL",
      display_name: "Display name",
      display_name_placeholder: "Ex: My Company",
      create_bio: "Create Bio Page",
      copy: "Copy",
      view_site: "View Site",
      link_copied: "Link copied!",
      views: "Views",
      clicks: "Clicks",
      links: "Links",
      my_links: "My Links",
      new_link: "New Link",
      add_link: "Add Link",
      link_type: "Link Type",
      link_title: "Title",
      link_url: "URL",
      link_description: "Description",
      link_icon: "Icon/Emoji",
      button_style: "Button Style",
      save_link: "Save Link",
      edit_link: "Edit Link",
      no_links: "No links added",
      add_first: "Add your first link",
      delete_link: "Delete link",
      design_tab: "Design",
      links_tab: "Links",
      integrations_tab: "Integr.",
      social_tab: "Social",
      bio: "Bio",
      theme_color: "Theme Color",
      background_color: "Background Color",
      text_color: "Text Color",
      button_type: "Button Style",
      font_family: "Font",
      profile_image: "Profile Photo",
      banner_image: "Banner",
      show_booking: "Show booking button",
      show_catalog: "Show catalog button",
      show_coupons: "Show coupons",
      show_products: "Show products",
      show_social: "Show social icons",
      show_categories: "Show categories",
      save_settings: "Save Settings",
      settings_saved: "Settings saved!",
      loading: "Loading...",
      link_types: {
        link: "External Link",
        product: "Product",
        video: "Video",
        image: "Image",
        whatsapp_group: "WhatsApp Group",
      },
      button_styles: {
        filled: "Filled",
        outline: "Outline",
        soft: "Soft",
        glass: "Glass",
      },
      // Additional linktree keys
      appearance: "Appearance",
      display_name_label: "Display Name",
      display_name_design_placeholder: "Your page name",
      font_label: "Font",
      bio_label: "Bio / Description",
      bio_placeholder: "A brief description about you or your company",
      main_color: "Main Color",
      background: "Background",
      text: "Text",
      button_style_label: "Button Style",
      profile_photo: "Profile Photo",
      banner: "Banner",
      save_design: "Save Design",
      catalog_integrations: "Catalog Integrations",
      catalog_settings: "Catalog settings on Bio Page",
      products_count: "Featured products",
      social_networks: "Social Networks",
      social_desc: "Add links to your social networks",
      instagram: "Instagram",
      facebook: "Facebook",
      whatsapp: "WhatsApp",
      tiktok: "TikTok",
      youtube: "YouTube",
      save_social: "Save Social Networks",
      edit_link_title: "Edit Link",
      save_changes: "Save Changes",
      catalog_button: "Catalog Button",
      catalog_button_desc: "Display catalog access button",
      featured_products: "Featured Products",
      featured_products_desc: "Show products from catalog",
      featured_products_count: "Number of featured products",
      products_count_label: "{{count}} products",
      booking_button: "Book Button",
      booking_button_desc: "Link to online booking",
      active_coupons: "Active Coupons",
      active_coupons_desc: "Show discount coupons",
      show_categories_label: "Show Categories",
      show_categories_desc: "Organize links by category",
      save_integrations: "Save Integrations",
      show_social_icons: "Show social network icons",
      show_social_icons_desc: "Display clickable icons on profile",
      title_required: "Title *",
      title_placeholder: "Ex: Our Instagram",
      url_label: "URL",
      url_placeholder: "https://",
      product_label: "Catalog Product",
      select_product: "Select a product",
      video_url_label: "Video URL (YouTube/Vimeo)",
      video_url_placeholder: "https://youtube.com/...",
      groups_available: "{{count}} group(s) available",
      no_groups_configured: "No groups configured",
      groups_rotate_hint: "Link will be automatically rotated to groups with spots",
      configure_groups_hint: "Configure groups in WhatsApp Groups first",
      description_optional: "Description (optional)",
      description_placeholder: "Brief link description",
      thumbnail: "Thumbnail",
      thumbnail_placeholder: "Link image",
      category_label: "Category",
      category_placeholder: "Ex: Social Networks",
      icon_label: "Icon (emoji)",
      add_link_btn: "Add Link",
      no_links_yet: "No links added yet",
      click_to_start: "Click \"New Link\" to get started",
      no_url: "No URL",
      active: "Active",
      inactive: "Inactive",
    },

    // Real Estate Module
    real_estate: {
      title: "Real Estate",
      subtitle: "Complete property, contract, and payment management",
      description: "Property and rental management",
      properties: "Properties",
      inspections: "Inspections",
      templates: "Templates",
      new_property: "New Property",
      register_property: "Register Property",
      search_placeholder: "Search properties...",
      search_property: "Search property...",
      filter_status: "Filter Status",
      all_status: "All",
      show_inactive: "Show inactive",
      no_property_found: "No property found",
      no_client_found: "No client found",
      add_photos: "Add Photos",
      property_types: {
        apartment: "Apartment",
        house: "House",
        commercial: "Commercial",
        land: "Land",
      },
      status: {
        available: "Available",
        rented: "Rented",
        sold: "Sold",
        maintenance: "Maintenance",
        inactive: "Inactive",
      },
      stats: {
        total: "Total",
        available: "Available",
        rented: "Rented",
        monthly_income: "Income/month",
        pending: "Pending",
      },
      tabs: {
        properties: "Properties",
        templates: "Templates",
        inspections: "Inspections",
        owners: "Owners",
        tenants: "Tenants",
        payments: "Payments",
        maintenance: "Maintenance",
      },
      fields: {
        title: "Title",
        address: "Address",
        type: "Type",
        bedrooms: "Bedrooms",
        bathrooms: "Bathrooms",
        parking: "Parking",
        area: "Area (sqm)",
        rent_value: "Rent Value",
        sale_value: "Sale Value",
        description: "Description",
        owner: "Owner",
        photo_gallery: "Photo Gallery",
      },
      placeholders: {
        title: "Ex: Downtown Apartment",
        address: "Street, number, neighborhood",
        description: "Property description...",
        select_owner: "Select owner...",
        search_client: "Search client...",
        select_tenant: "Select tenant...",
        room_name: "Room name",
        add_item: "Add item...",
        select_property: "Select property...",
        search_property: "Search property...",
      },
      payment_types: {
        rent: "Rent",
        deposit: "Deposit",
        condominium: "Condominium",
        water: "Water",
        electricity: "Electricity",
        iptu: "Property Tax",
        other: "Other",
      },
    },

    quick_create: {
      create: "Create",
      new_customer: "New Customer",
      new_sale: "New Sale",
      new_appointment: "New Appointment",
      new_task: "New Task",
      new_proposal: "New Proposal",
    },

    goals: {
      title: "Goals and KPIs",
      description: "Define and track your business goals",
      new_goal: "New Goal",
      create_goal: "Create Goal",
      goal_name: "Goal name",
      goal_name_placeholder: "Ex: January Revenue",
      type: "Type",
      target_value: "Target value",
      start: "Start",
      end: "End",
      search_goals: "Search goals...",
      filter_type: "Filter type",
      all_types: "All types",
      active_goals: "Active Goals",
      history: "Goals History",
      progress: "Progress",
      current: "Current",
      target: "Target",
      no_goals_found: "No goals found",
      try_filters: "Try changing the filters",
      start_creating: "Start by creating your first goals",
      completed: "Completed",
      not_achieved: "Not achieved",
      types: { revenue: "Revenue", sales_count: "Sales Count", new_customers: "New Customers", appointments: "Appointments", products_sold: "Products Sold", services_sold: "Services Sold" },
    },

    lead_funnel: {
      analytics_title: "AI Funnel Analytics",
      analytics_description: "Metrics and qualification funnel performance",
      total_leads: "Total Leads",
      hot_leads: "Hot Leads",
      conversion_rate: "Conversion Rate",
      scheduling_rate: "Scheduling Rate",
      avg_score: "Average Lead Score",
      hot: "Hot",
      warm: "Warm",
      cold: "Cold",
      funnel_by_stage: "Funnel by Stage",
      classification: "Lead Classification",
      recent_leads: "Recent Leads",
      no_name: "No name",
      no_leads_yet: "No leads captured yet.",
      stages: { new: "New", qualifying: "Qualifying", qualified: "Qualified", scheduled: "Scheduled", converted: "Converted", lost: "Lost" },
      sources: { manual: "Manual", form: "Form", crm_customer: "CRM Customer", import: "Import" },
    },

    checklist: {
      title: "Checklists",
      description: "Manage routines and inspections",
      new_checklist: "New Checklist",
      create_checklist: "Create Checklist",
      name_placeholder: "Ex: Opening Checklist",
      description_optional: "Description (optional)",
      describe_checklist: "Describe the checklist...",
      checklist_items: "Checklist Items",
      item_description: "Item description",
      templates: "Templates",
      history: "History",
      search_checklist: "Search checklist...",
      all_types: "All types",
      no_checklists_created: "No checklists created",
      no_checklists_found: "No checklists found",
      create_first: "Create your first checklist to get started",
      try_filters: "Try adjusting the filters",
      items: "items",
      execute: "Execute",
      no_executions: "No executions recorded",
      by: "by",
      complete: "Complete",
      partial: "Partial",
      type_here: "Type...",
      finish_checklist: "Finish Checklist",
      types: { opening: "Opening", closing: "Closing", cleaning: "Cleaning", inspection: "Inspection", epi: "PPE", general: "General" },
      field_types: { boolean: "Yes/No", text: "Text", number: "Number" },
    },

    gym: {
      title: "Gym",
      description: "Student, workout, and physical evolution management",
      students: "Students",
      plans: "Plans",
      workouts: "Workouts",
      workout: "Workout",
      evolution: "Evolution",
      nutrition: "Diet",
      active_plans: "Active Plans",
      expiring: "Expiring",
      search_student: "Search student...",
      no_students_found: "No students found",
      no_phone: "No phone",
      new_plan: "New Plan",
      create_plan: "Create Plan",
      create_plan_for_student: "Create Plan for Student",
      student: "Student",
      plan: "Plan",
      price: "Price",
      duration_months: "Duration",
      start_date: "Start Date",
      new_workout: "New Workout",
      create_workout: "Create Workout",
      workout_title: "Workout Title",
      workout_description: "Description",
      level: "Level",
      exercises: "Exercises",
      add_exercise: "Add",
      no_workouts_found: "No workouts found",
      no_workouts_desc: "Create custom workouts or use templates",
      fill_required_fields: "Fill in all required fields.",
      fill_workout_title: "Fill in the workout title.",
      select_student_first: "Select a student first.",
      error_creating_workout: "Error creating workout:",
      error_generating_suggestion: "Error generating workout suggestion.",
      suggestion_generated: "Suggestion generated.",
      levels: { beginner: "Beginner", intermediate: "Intermediate", advanced: "Advanced" },
      plan_types: { monthly: "Monthly", quarterly: "Quarterly", semiannual: "Semiannual", annual: "Annual" },
      ai_prompts: { beginner: "Create a beginner workout plan with 3 days per week, including basic exercises with sets and reps.", intermediate: "Create an intermediate workout plan with 4 days per week, focusing on hypertrophy.", advanced: "Create an advanced workout plan with 5 days per week, advanced intensity techniques." },
    },

    delivery: {
      title: "Own Delivery",
      description: "Manage deliveries, zones, and drivers",
      orders: "Orders",
      zones: "Zones",
      drivers: "Drivers",
      settings: "Settings",
      total_orders: "Total Orders",
      pending: "Pending",
      out_for_delivery: "Out for Delivery",
      delivered: "Delivered",
      cancelled: "Cancelled",
      deliveries_today: "Deliveries by Driver (Today)",
      delivery_orders: "Delivery Orders",
      no_orders_found: "No orders found",
      order_code: "Code",
      customer: "Customer",
      address: "Address",
      driver: "Driver",
      fee: "Fee",
      assign: "Assign",
      previous: "Previous",
      next: "Next",
      page_of: "Page {{current}} of {{total}}",
      orders_found: "{{count}} order(s) found",
      new_zone: "New Zone",
      create_zone: "Create Zone",
      zone_name: "Zone Name",
      neighborhoods: "Neighborhoods",
      delivery_time: "Delivery Time",
      minutes: "minutes",
      no_zones: "No zones registered",
      no_zones_desc: "Create delivery zones to set rates by region",
      new_driver: "New Driver",
      edit_driver: "Edit Driver",
      create_driver: "Register Driver",
      driver_name: "Driver Name",
      vehicle_type: "Vehicle Type",
      available: "Available",
      unavailable: "Unavailable",
      no_drivers: "No drivers registered",
      no_drivers_desc: "Register drivers for your delivery team",
      save_settings: "Save Settings",
      saving: "Saving...",
      settings_saved: "Settings saved!",
      whatsapp_notifications: "WhatsApp Notifications",
      whatsapp_notifications_desc: "Send automatic status updates",
      status: { pending: "Pending", preparing: "Preparing", ready: "Ready", out_for_delivery: "Out for Delivery", delivered: "Delivered", cancelled: "Cancelled", rejected: "Rejected" },
      vehicle_types: { moto: "Motorcycle", bicicleta: "Bicycle", carro: "Car", a_pe: "On foot" },
    },

    // Commissions
    commissions: {
      title: "Commissions",
      subtitle: "Manage commission rules and payments",
      new_rule: "New Rule",
      active_rules: "Active Rules",
      pending: "Pending",
      paid_period: "Paid (period)",
      total_period: "Total (period)",
      tabs: { summary: "Summary by Professional", entries: "Entries", rules: "Rules" },
      start_date: "Start Date",
      end_date: "End Date",
      no_commissions_period: "No commissions in this period",
      entries_count: "{{count}} entries",
      pending_label: "pending",
      paid_label: "paid",
      search_professional: "Search by professional...",
      professional: "Professional",
      pay_selected: "Pay Selected ({{count}})",
      no_entries: "No entries found",
      paid: "Paid",
      no_rules: "No rules registered",
      all_professionals: "All professionals",
      new_commission_rule: "New Commission Rule",
      service: "Service",
      all_services: "All services",
      percentage: "Percentage (%)",
      fixed_value: "Fixed Value",
      create_rule: "Create Rule",
    },

    // Communication
    communication: {
      chat: "Chat",
      create_channel: "Create Channel",
      channel_name: "Channel name",
      channel_name_placeholder: "E.g: #general, #sales",
      members_access: "Members with access",
      members_access_desc: "Leave empty for all team members to have access",
      member: "Member",
      channels: "Channels",
      no_channels: "No channels",
      team: "Team",
      my_status: "My status",
      status: { online: "Online", away: "Away", busy: "Busy", offline: "Offline" },
      roles: { owner: "Owner", admin: "Admin", staff: "Staff" },
      rename: "Rename",
      manage_members: "Manage members",
      delete_channel: "Delete channel",
      select_channel: "Select a channel",
      loading_messages: "Loading messages...",
      no_messages: "No messages yet.",
      be_first: "Be the first to write!",
      user: "User",
      mention: "Mention",
      message_placeholder: "Type your message... Use @ to mention",
      rename_channel: "Rename Channel",
      new_name: "New name",
      delete_channel_confirm: "Are you sure you want to delete this channel? All messages will be lost.",
      manage_channel_members: "Manage Channel Members",
      manage_members_desc: "Select who can see and send messages in this channel. Leave empty for everyone to have access.",
      all_have_access: "All team members will have access",
      members_selected: "{{count}} member(s) selected",
    },

    // Webhooks
    webhooks: {
      title: "Webhooks",
      subtitle: "Configure URLs to receive system event notifications",
      new_webhook: "New Webhook",
      create_webhook: "Create Webhook",
      create_description: "Configure a URL to receive notifications when events occur",
      url: "Webhook URL",
      events: "Events",
      configured: "Configured Webhooks",
      manage_description: "Manage webhooks that will receive event notifications",
      no_webhooks: "No webhooks configured",
      fill_url_events: "Fill in the URL and select at least one event",
      created: "Webhook created successfully",
      logs: "Webhook Logs",
      logs_description: "Last 50 calls made to this webhook",
      no_logs: "No logs found",
      no_response: "No response",
      delete_title: "Delete Webhook",
      delete_confirm: "Are you sure you want to delete this webhook? This action cannot be undone.",
    },

    // Packages
    packages: {
      title: "Packages & Sessions",
      subtitle: "Manage service packages and credits",
      sell_package: "Sell Package",
      new_package: "New Package",
      package_types: "Package Types",
      total_sold: "Total Sold",
      active_packages: "Active Packages",
      completed: "Completed",
      sessions: "sessions",
      remaining: "remaining",
      consume: "Consume",
      renew: "Renew",
      package_sales: "Package Sales",
      search_placeholder: "Search by customer or package...",
      all: "All",
      active: "Active",
      cancelled: "Cancelled",
      no_packages_sold: "No packages sold found",
      no_package_types: "No package types registered",
      new_package_type: "New Package Type",
      name: "Name",
      name_placeholder: "Ex: 10 Session Package",
      qty_sessions: "Qty. Sessions",
      price: "Price",
      linked_service: "Linked Service",
      optional: "Optional",
      description: "Description",
      description_placeholder: "Optional description...",
      create: "Create Package",
      select_customer: "Select Customer",
      select_package: "Select Package",
      expiration: "Expiration",
      sell: "Sell Package",
      renew_package: "Renew Package",
      additional_sessions: "Additional Sessions",
      new_expiration: "New Expiration",
      confirm_renew: "Renew Package",
    },

    // Quotes
    quotes: {
      title: "Quotes",
      subtitle: "Create and send commercial proposals to your customers",
      description: "Create and send commercial proposals to your customers",
      new_quote: "New Quote",
      edit_quote: "Edit Quote",
      create_quote: "Create Quote",
      save_changes: "Save Changes",
      total: "Total",
      status: {
        draft: "Draft",
        sent: "Sent",
        approved: "Approved",
        rejected: "Rejected",
      },
      draft: "Draft",
      sent: "Sent",
      approved: "Approved",
      rejected: "Rejected",
      total_approved: "Total Approved",
      approved_value: "Approved Value",
      customer: "Customer",
      select_customer: "Select customer",
      search_customer: "Search customer...",
      no_customer_found: "No customer found.",
      customer_placeholder: "Select customer",
      title_label: "Title",
      title_placeholder: "Ex: Service proposal",
      description_optional: "Description (optional)",
      refine_with_ai: "Refine with AI",
      proposal_details: "Proposal details...",
      description_placeholder: "Proposal details...",
      items: "Items",
      item: "Item",
      add: "Add",
      item_name: "Item name",
      quantity_short: "Qty",
      qty: "Qty",
      price: "Price",
      unit_price: "Unit Price",
      subtotal: "Subtotal",
      discount: "Discount",
      search_placeholder: "Search by title or customer...",
      all_status: "All status",
      no_quotes: "No quotes",
      start_creating: "Start creating your first quote",
      create_first: "Create your first quote",
      send: "Send",
      copy_link: "Copy Link",
      view: "View",
      print: "Print",
      edit: "Edit",
      delete: "Delete",
      share: "Share",
      convert_contract: "Convert to Contract",
      generate_contract: "Generate Contract",
      create_project: "Create Project",
      approve: "Approve",
      reject: "Reject",
      delete_quote: "Delete Quote",
      delete_confirmation: "Are you sure you want to delete this quote? This action cannot be undone.",
      delete_confirm: "Are you sure you want to delete this quote?",
      share_quote: "Share Quote",
      share_message: "Hello {{name}}, here is your quote link:",
      quote_details: "Quote Details",
      created_at: "Created at",
      responded_at: "Responded at",
      generated_at: "Generated at",
      add_title_or_description_first: "Add a title or description first",
      proposal_refined: "Proposal refined with AI!",
      could_not_refine: "Could not refine the proposal",
      refine_error: "Error refining proposal",
      link_copied: "Link copied!",
      sent_success: "Quote sent!",
      approved_success: "Quote approved!",
      rejected_success: "Quote rejected!",
      converted_success: "Contract created!",
      project_created: "Project created!",
      deleted: "Quote deleted!",
    },

    // NPS
    nps: {
      title: "NPS Survey",
      subtitle: "Track customer satisfaction",
      score: "NPS Score",
      excellent: "Excellent",
      very_good: "Very good",
      reasonable: "Reasonable",
      needs_improvement: "Needs improvement",
      promoters: "Promoters",
      passives: "Passives",
      detractors: "Detractors",
      scores_9_10: "Scores 9-10",
      scores_7_8: "Scores 7-8",
      scores_0_6: "Scores 0-6",
      responses_tab: "Responses",
      config_tab: "Settings",
      search_placeholder: "Search by customer or comment...",
      category: "Category",
      all: "All",
      promoters_filter: "Promoters (9-10)",
      passives_filter: "Passives (7-8)",
      detractors_filter: "Detractors (0-6)",
      pending_filter: "Not answered",
      loading: "Loading...",
      no_surveys: "No surveys found",
      surveys_auto_sent: "Surveys will be sent automatically after appointments",
      try_filters: "Try adjusting filters",
      customer: "Customer",
      responded_at: "Responded on",
      sent_at: "Sent on",
      comment: "Comment",
      not_responded: "Not responded",
      promoter: "Promoter",
      passive: "Passive",
      detractor: "Detractor",
      auto_send: "Auto Send",
      send_after_appointment: "Send after appointment",
      send_after_description: "Automatically sends survey after completed appointments",
      wait_time: "Wait time (minutes)",
      wait_time_description: "Time after appointment to send survey",
      survey_questions: "Survey Questions",
      survey_questions_description: "Customize the questions your customers will see",
      main_question: "Main Question (Score)",
      main_question_placeholder: "On a scale of 0 to 10, how likely are you to recommend our service to a friend or colleague?",
      main_question_description: "Question shown with the 0-10 scale",
      comment_question: "Comment Question",
      comment_question_description: "Optional question to collect text feedback",
      comment_prompt_default: "What motivated your score?",
      preview: "Survey Preview",
      your_comment: "Your comment (optional)",
      save_config: "Save Settings",
      saving: "Saving...",
      config_saved: "Settings saved!",
    },

    // Satisfaction
    satisfaction: {
      title: "Satisfaction Surveys",
      subtitle: "Send surveys and track customer satisfaction",
      new_survey: "New Survey",
      share_survey: "Share Survey",
      send_survey: "Send Satisfaction Survey",
      select_customer: "Select customer",
      create_survey: "Create Survey",
      survey_link: "Survey link:",
      copy_link: "Copy Link",
      whatsapp: "WhatsApp",
      email: "Email",
      done: "Done",
      avg_score: "Overall Average",
      nps_score: "NPS Score",
      total_responses: "Total Responses",
      churn_risk: "Churn Risk",
      search_placeholder: "Search surveys...",
      sent_surveys: "Sent Surveys",
      loading: "Loading...",
      no_surveys: "No surveys found",
      customer: "Customer",
      score: "Score",
      sentiment: "Sentiment",
      feedback: "Feedback",
      date: "Date",
      status: "Status",
      actions: "Actions",
      responded: "Responded",
      pending: "Pending",
      positive: "positive",
      negative: "negative",
      neutral: "neutral",
      link_copied: "Link copied!",
      sent_whatsapp: "Survey sent via WhatsApp!",
      no_phone: "Customer has no registered phone",
      no_instance: "No WhatsApp instance connected",
      error_whatsapp: "Error sending WhatsApp",
    },

    // Referrals
    referrals: {
      title: "Referral Program",
      subtitle: "Manage your customer referral program",
      total_referrals: "Total Referrals",
      converted: "Converted",
      pending: "Pending",
      conversion_rate: "Conversion Rate",
      program_tab: "Program",
      referrals_tab: "Referrals",
      status: "Status",
      active: "Active",
      inactive: "Inactive",
      paused: "Paused",
      referred_reward: "Referred Reward",
      referrer_reward: "Referrer Reward",
      discount: "discount",
      no_program: "No active program",
      no_program_description: "Set up a referral program for your customers",
      received_referrals: "Received Referrals",
      no_referrals: "No referrals received yet",
      referred: "Referred",
      date: "Date",
      status_pending: "Pending",
      status_converted: "Converted",
      status_rewarded: "Rewarded",
      status_expired: "Expired",
    },

    // Reactivation
    reactivation: {
      title: "Customer Reactivation",
      subtitle: "Win back inactive customers",
      inactive_30: "+30 days inactive",
      inactive_60: "+60 days inactive",
      inactive_90: "+90 days inactive",
      potential_revenue: "Potential Revenue",
      search_placeholder: "Search customer...",
      period: "Period",
      days_30: "+30 days",
      days_60: "+60 days",
      days_90: "+90 days",
      days_180: "+180 days",
      email: "Email",
      whatsapp: "WhatsApp",
      inactive_customers: "Inactive Customers",
      select_all: "Select all",
      deselect_all: "Deselect all",
      no_inactive: "No inactive customers found",
      great_news: "Great! Your customers are active.",
      days: "days",
      last_visit: "Last:",
      never_visited: "Never visited",
      visits: "visits",
      select_at_least_one: "Select at least one customer",
      no_whatsapp_instance: "No WhatsApp instance connected",
      messages_sent: "messages sent",
      failures: "failures",
      emails_sent: "emails sent",
    },

    // Automations
    automations: {
      title: "Automations",
      subtitle: "Configure automatic actions based on customer behavior",
      new_automation: "New Automation",
      create_automation: "Create New Automation",
      automation_name: "Automation name *",
      automation_name_placeholder: "E.g.: Inactive customer reactivation",
      after_create_hint: "After creating, you will be directed to the visual editor where you can configure triggers, conditions and actions.",
      creating: "Creating...",
      create_and_configure: "Create and Configure",
      search_placeholder: "Search automation...",
      status_all: "All",
      status_active: "Active",
      status_inactive: "Inactive",
      loading: "Loading...",
      no_automation_configured: "No automation configured",
      no_automation_found: "No automation found",
      create_automations_hint: "Create automations to automatically engage your customers",
      try_filters: "Try adjusting the filters",
      create_first: "Create first automation",
      active: "Active",
      inactive: "Inactive",
      delete_title: "Delete Automation",
      delete_description: "Are you sure you want to delete this automation? This action cannot be undone.",
      tags_count: "tag(s)",
    },

    // Tags Management
    tags_management: {
      title: "Tags / Labels",
      subtitle: "Organize and categorize your customers with custom tags",
      new_tag: "New Tag",
      edit_tag: "Edit Tag",
      tag_name: "Tag Name *",
      tag_name_placeholder: "E.g.: VIP, Premium, New customer...",
      color: "Color",
      description_placeholder: "Optional description...",
      update: "Update",
      create: "Create Tag",
      name_required: "Name is required",
      tag_updated: "Tag updated!",
      tag_created: "Tag created!",
      tag_deleted: "Tag deleted!",
      total_tags: "Total Tags",
      customers_with_tags: "Customers with Tags",
      tags_per_customer: "Tags per Customer (avg)",
      search_placeholder: "Search tags...",
      loading: "Loading...",
      no_tag_created: "No tag created",
      no_tag_found: "No tag found",
      create_tags_hint: "Create tags to organize and categorize your customers",
      try_search: "Try adjusting the search",
      create_first: "Create first tag",
      customers: "customer(s)",
      delete_title: "Delete Tag",
      delete_description: "Are you sure you want to delete this tag? It will be removed from all customers.",
      colors: {
        blue: "Blue",
        green: "Green",
        red: "Red",
        yellow: "Yellow",
        purple: "Purple",
        pink: "Pink",
        orange: "Orange",
        teal: "Teal",
      },
    },

    // E-commerce
    ecommerce: {
      title: "E-commerce",
      subtitle: "Manage orders and payments from your store",
      orders: "Orders",
      payments: "Payments",
      products: "Products",
      settings: "Settings",
      total_orders: "Total Orders",
      pending: "Pending",
      revenue: "Revenue",
      avg_ticket: "Avg Ticket",
      search_placeholder: "Search by customer, email or ID...",
      filter_status: "Filter status",
      all_statuses: "All statuses",
      no_orders: "No orders found",
      orders_appear: "Orders will appear here when customers purchase from your store.",
      order_details: "Order Details",
      tracking_code: "Tracking Code",
      tracking_placeholder: "Enter tracking code",
      mark_shipped: "Mark as Shipped",
      customer: "Customer",
      shipping_address: "Shipping Address",
      items: "Items",
      qty: "Qty",
      subtotal: "Subtotal",
      shipping: "Shipping",
      discount: "Discount",
      total: "Total",
      status_updated: "Status updated",
      products_info_title: "Manage your products",
      products_info_desc: "Products registered in Inventory appear here. Enable the ones you want to sell online.",
      go_to_products: "Go to Inventory & Products →",
      search_products: "Search products...",
      no_products_found: "No products found",
      no_products: "No products registered",
      try_different_search: "Try a different search",
      add_products_first: "Register products in Inventory to sell them here.",
      add_product: "Add Product",
      low_stock: "Low stock",
      active: "Active",
      inactive: "Inactive",
      stock: "Stock",
      sell_online: "Sell online",
      product_enabled: "Product enabled",
      product_disabled: "Product disabled",
      product_enabled_desc: "The product is now visible in the store",
      product_disabled_desc: "The product has been hidden from the store",
      update_error: "Error updating product",
      store_url: "Store Link",
      store_url_description: "Share this link for customers to access your store",
      configure_slug: "Configure your company slug in settings for a custom link.",
      url_copied: "Store link copied to clipboard",
      shipping_settings: "Shipping Settings",
      default_shipping: "Default shipping fee",
      shipping_fee_note: "Set 0 for free shipping",
      min_order_value: "Minimum order",
      min_order_note: "Minimum value to complete order",
      free_shipping_above: "Free shipping above",
      free_shipping_note: "Offer free shipping for orders above a value",
      notification_settings: "Notifications",
      whatsapp_notifications: "WhatsApp notifications",
      whatsapp_note: "Receive new order alerts on WhatsApp",
      email_notifications: "Email notifications",
      email_note: "Receive new order alerts by email",
      customer_notifications: "Notify customers",
      customer_note: "Send status updates to customers",
      store_settings: "Store Settings",
      store_enabled: "Store active",
      store_enabled_note: "Disable to temporarily pause sales",
      show_prices: "Show prices",
      show_prices_note: "Display product prices in the store",
      show_stock: "Show stock",
      show_stock_note: "Display available quantity",
      configure_payments: "Configure Payments",
      stripe_not_configured: "Payments not configured",
      stripe_description: "Set up your account to receive payments directly. Sales go straight to your bank account.",
      how_it_works: "How it works",
      step_1_title: "Connect your account",
      step_1_desc: "Click the button below to create your Stripe account. It's free.",
      step_2_title: "Complete registration",
      step_2_desc: "Fill in your bank details and documents for verification.",
      step_3_title: "Start selling!",
      step_3_desc: "After approval, you can receive by card, PIX and more.",
      benefit_security: "Secure",
      benefit_security_desc: "Fraud protection",
      benefit_transfers: "Automatic",
      benefit_transfers_desc: "Automatic transfers",
      benefit_methods: "Multiple methods",
      benefit_methods_desc: "Card, PIX, boleto",
      connect_stripe: "Connect with Stripe",
      stripe_note: "Stripe charges ~3.5% + $0.30 per transaction. No monthly fees.",
      stripe_account: "Stripe Account",
      account_status: "Account Status",
      status_active: "Active",
      status_pending: "Pending",
      receive_payments: "Receive Payments",
      receive_payouts: "Receive Payouts",
      enabled: "Enabled",
      incomplete_setup: "Incomplete setup",
      incomplete_description: "Your account needs additional information to start receiving payments.",
      complete_registration: "Complete Registration",
      ready_to_sell: "Ready to sell!",
      ready_description: "Your account is active. Payments will be transferred automatically.",
      manage_stripe: "Manage on Stripe",
      status: {
        pending: "Pending",
        paid: "Paid",
        processing: "Processing",
        shipped: "Shipped",
        delivered: "Delivered",
        cancelled: "Cancelled",
        refunded: "Refunded",
      },
      stripe_connect: {
        title: "Stripe Connect",
        description: "Connect your Stripe account to receive payments directly to your bank account.",
        setup: "Setup Stripe Connect",
        setting_up: "Setting up...",
        status_pending: "Pending",
        status_active: "Active",
        payments_enabled: "Payments enabled",
        payouts_enabled: "Payouts enabled",
        go_to_dashboard: "Go to Stripe Dashboard",
      },
    },
    
    // Security & Privacy
    security: {
      title: "Security & Privacy",
      description: "Data protection and security settings",
      access_token: "Access Token",
      access_token_description: "Unique token for secure order access",
      token_generated: "Token generated automatically",
      token_secure: "Secure access via token",
      track_order: "Track Order",
      order_link: "Order Link",
      copy_link: "Copy Link",
      link_copied: "Link copied!",
      send_to_customer: "Send to Customer",
      data_protection: "Data Protection",
      sensitive_data: "Sensitive Data",
      restricted_access: "Restricted Access",
      only_owners_admins: "Only owners and administrators",
      staff_can_view_own: "Staff can view their own data",
      salary_hidden: "Salary hidden from others",
      bank_data_protected: "Bank data protected",
      access_levels: "Access Levels",
      owner: "Owner",
      admin: "Administrator",
      manager: "Manager",
      staff_role: "Staff",
      full_access: "Full access",
      limited_access: "Limited access",
      view_only: "View only",
      lgpd_compliance: "LGPD Compliance",
      hipaa_compliance: "HIPAA Compliance",
      data_encrypted: "Data encrypted",
      audit_logs: "Audit logs",
      two_factor_auth: "Two-factor authentication",
      session_timeout: "Session timeout",
    },
    
    // Reviews Module
    reviews: {
      title: "Reviews",
      subtitle: "Manage reviews and business reputation",
      average_rating: "Average Rating",
      total: "Total Reviews",
      pending: "Pending",
      public: "Public",
      distribution: "Rating Distribution",
      all_reviews: "All Reviews",
      search: "Search reviews...",
      all: "All",
      approved: "Approved",
      approve: "Approve",
      reject: "Reject",
      respond: "Respond",
      hide: "Hide",
      show: "Make Public",
      no_reviews: "No reviews found",
      no_comment: "No comment",
      your_response: "Your response:",
      write_response: "Write your response...",
      send_response: "Send Response",
      // Display settings
      settings: "Settings",
      display_settings: "Display Settings",
      display_settings_desc: "Choose where your approved reviews will be displayed",
      locations: "Locations",
      widget: "Widget",
      minisite: "Mini-site",
      minisite_desc: "Display reviews on the main mini-site page",
      catalog: "Catalog",
      catalog_desc: "Display reviews on the product catalog",
      store: "Store",
      store_desc: "Display reviews on the online store",
      max_displayed: "Maximum reviews displayed",
      show_stats: "Show statistics",
      show_stats_desc: "Display average rating and total reviews",
      enable_widget: "Enable Widget",
      enable_widget_desc: "Allows embedding reviews on external sites",
      js_widget: "JavaScript Widget",
      iframe_widget: "iFrame Widget",
      copy: "Copy",
      preview: "Preview",
      preview_hint: "Reviews will appear here when you embed the widget on your external site.",
      code_copied: "{{type}} code copied!",
      // Public display
      public_title: "What our customers say",
      reviews_count: "reviews",
      anonymous: "Customer",
      business_response: "Business response:",
    },
  },
};
